import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import Box from "@material-ui/core/Box";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import clsx from 'clsx'
import MailIcon from '@material-ui/icons/Mail';
import ChatBubbleIcon from '@mui/icons-material/MessageRounded';

import DraftsIcon from '@material-ui/icons/Drafts';

const useStyles = makeStyles({
  table: {

  },
  tableRightBorder: {
    borderWidth: 1,
    borderColor: "rgba(0,0,0,0.1)",
    borderStyle: "solid",
  },
  tableFont: {
    fontSize: '16px', 
    fontFamily: 'Montserrat', 
    
  },
  tableHeader :{
    fontSize: '16px', 
    fontFamily: 'Montserrat', 
    color: "#212529",
    fontWeight: 600
  },
  root: {
    padding: "50px 10%",
  },
});

const data = [
  {
    number: 1,
    date: `${new Date().getDate()}-${new Date().getMonth()}-${new Date().getFullYear()}`,
    opened: true,
    sentBy: "Narendra Modi",
    sentTo: "Joe Biden",
    subject: "Peace Treaty",
    messageLink: "",
  },
  {
    number: 1,
    date: `${new Date().getDate()}-${new Date().getMonth()}-${new Date().getFullYear()}`,
    opened: true,
    sentBy: "Narendra Modi",
    sentTo: "Joe Biden",
    subject: "Peace Treaty",
    messageLink: "",
  },
  {
    number: 1,
    date: `${new Date().getDate()}-${new Date().getMonth()}-${new Date().getFullYear()}`,
    opened: false,
    sentBy: "Narendra Modi",
    sentTo: "Joe Biden",
    subject: "Peace Treaty",
    messageLink: "",
  },
];

export default function BasicTable() {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell className={clsx(classes.tableRightBorder, classes.tableHeader)}>NO.</TableCell>
              <TableCell className={clsx(classes.tableRightBorder, classes.tableHeader)}>DATE</TableCell>
              <TableCell className={clsx(classes.tableRightBorder, classes.tableHeader)}>STATUS</TableCell>
              <TableCell className={clsx(classes.tableRightBorder, classes.tableHeader)}>
                SENT BY
              </TableCell>
              <TableCell className={clsx(classes.tableRightBorder, classes.tableHeader)}>
                SENT TO
              </TableCell>
              <TableCell className={clsx(classes.tableRightBorder, classes.tableHeader)}>
                SUBJECT
              </TableCell>
              <TableCell className={clsx(classes.tableRightBorder, classes.tableHeader)}>
                VIEW MESSAGE
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((datum, index) => (
              <TableRow key={index}>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableFont)}>{index + 1}</TableCell>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableFont)}>{datum.date}</TableCell>
                <TableCell align="center" className={clsx(classes.tableRightBorder, classes.tableFont)}>
                  {datum.opened ? <DraftsIcon /> : <ChatBubbleIcon />}
                </TableCell>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableFont)}>{datum.sentBy}</TableCell>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableFont)}>{datum.sentTo}</TableCell>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableFont)}>{datum.subject}</TableCell>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableFont)}><span style={{color: '#3ac2d7', textDecoration: 'underline'}} > Click Here</span></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
